/**
 * Created by uttam on 12/20/17.
 */

export const SET_PORTFOLIO_TOTAL = 0;
export const ADD_OVERVIEW = 3;
export const DELETE_TRANSACTION = 4;
export const BUY_SELL_PATCH = 5;
export const CHANGE_TAB = 6;
export const POP_MODAL = 7;
export const PORTFOLIO_SELECT_CHANGE = 8;
export const ADD_PORTFOLIO = 9;
export const IMPORT_PORTFOLIO = 10;
export const DELETE_PORTFOLIO = 11;
export const SET_PERFORMANCE_LIST = 12;
export const PUSH_MODAL = 13;
export const SELECT_DONUT_ARC = 14;

// Added by jiwan
export const IMPORT_PORTFOLIO_FROM_EXCEL = 'IMPORT_PORTFOLIO_FROM_EXCEL';
export const UPDATE_PORTFOLIO_FROM_EXCEL = 'UPDATE_PORTFOLIO_FROM_EXCEL';




// WEBPACK FOOTER //
// ./src/topic/Portfolio/ActionTypes.js